<template>
  <v-container grid-list-lg>
    <v-layout row wrap>
      <v-flex lg12 class="userInfo">
        <div class="historyBox" v-for="history in objDateHistory">
          <table width="100%">
            <tr>
              <td><strong>NEW DATE:</strong></td>
              <td>{{ history.new_value }}</td>
            </tr>
            <tr>
              <td><strong>PREVIOUS DATE:</strong></td>
              <td>{{ history.prev_value }}</td>
            </tr>
            <tr>
              <td><strong>DATE CHANGED:</strong></td>
              <td>{{ history.timestamp }}</td>
            </tr>
            <tr>
              <td><strong>CHANGED BY:</strong></td>
              <td>{{ history.name }}</td>
            </tr>
          </table>
        </div>
      </v-flex>
      <div class="pl-4 pr-1 pb-4 buttonHolder">
        <div style="float: right">
          <v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Close</v-btn>
        </div>
      </div>
    </v-layout>
  </v-container>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "Modal_Date_History",
  data() {
    return {

    };
  },
  methods: {
    fncHideModal() {
      this.$store.commit('hideModal');
    },
    fncGetInstallationDate(objItem) {
      if (!objItem || objItem === 'N/A') {
        return 'N/A';
      }

      // const sanitizedItem = objItem[1].replace(/["'/:\\]/g, ''); // Remove unwanted characters
      // const dateArray = sanitizedItem.split(',');
      //
      // const installationDate = dateArray[dateArray.length - 1].trim();

      var newSplit = objItem[1].replace(/"/g, "");
      newSplit = newSplit.replace(/'/g, "");
      newSplit = newSplit.replace(/\//g,'')
      newSplit = newSplit.split('\\');
      var installationDate = newSplit[2];
      //var onjInstallDate = installationDate.split(',');
      //installationDate = installationDate[ installationDate.length - 1 ]

      const dateObj = new Date(newSplit);

      if (!isNaN(dateObj)) {
        const year = dateObj.getUTCFullYear();
        const month = String(dateObj.getUTCMonth() + 1).padStart(2, '0');
        const day = String(dateObj.getUTCDate()).padStart(2, '0');
        const hours = String(dateObj.getUTCHours()).padStart(2, '0');
        const minutes = String(dateObj.getUTCMinutes()).padStart(2, '0');
        const seconds = String(dateObj.getUTCSeconds()).padStart(2, '0');

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      }

      return 'N/A';
    }
  },
  computed: {
    ...mapGetters([
      'objAuthorize',
      'globalModalParams',
      'objDateHistory',
    ]),

  },
}
</script>

<style scoped>

</style>
